import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Checkbox, InputAdornment, Menu, MenuItem, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

import { DataAPIContext, GET_LIST } from '../api';

const CheckboxOptionsSelect = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const [tripItemsCategories, setTripItemsCategories] = useState([]);
    const [query, setQuery] = useState(null);


    React.useEffect(() => {
        const getTripItemCategories = async () => {
            const res = await dataAPI(GET_LIST, 'pre_trip_item_type', { pagination: { perPage: 100 }, query: query })
            setTripItemsCategories(res.data.map(cat => ({ ...cat, selected: false })));
        }

        getTripItemCategories()
    }, [query])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCheckboxToggle = (selected) => {
        setTripItemsCategories(prev => {
            let updatedTripItems = [...prev];
            updatedTripItems = updatedTripItems.map(item => {
                item = item.id === selected.id ? { ...item, selected: !item.selected } : item
                return item
            })
            props.setRecordListFilters(prev => {
                let new_filters = updatedTripItems.filter(item => item.selected).map(item => item.id)
                if (new_filters && new_filters.length > 0) {
                    return updatedTripItems.filter(item => item.selected).map(item => item.id)
                }
                return null
            })
            return updatedTripItems
        })


    };

    return (
        <>
            <TextField
                variant="filled"
                size="small"
                onClick={handleClick}
                id="outlined-multiline-static"
                label="Category"
                value={query}
                onChange={ev => setQuery(ev.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <ArrowDropDownIcon />
                        </InputAdornment>
                    ),
                }}
            />
            <Menu anchorEl={anchorEl} style={{ maxHeight: '400px' }} open={Boolean(anchorEl)} onClose={handleClose}>
                {tripItemsCategories.length > 0 ? tripItemsCategories.map((item) => (
                    <MenuItem key={item.id} onClick={() => handleCheckboxToggle(item)}>
                        <Checkbox checked={item.selected} />
                        {item.name}
                    </MenuItem>
                )) : <Typography p={1}>No matches</Typography>}
            </Menu>
        </>
    );
};

export default CheckboxOptionsSelect;
